/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdUploadProps } from './type';

export const uploadDefaultProps: TdUploadProps = {
  addBtn: true,
  allowUploadDuplicateFile: false,
  autoUpload: true,
  disabled: undefined,
  defaultFiles: [],
  max: 0,
  method: 'POST',
  multiple: false,
  preview: true,
  removeBtn: true,
  theme: 'grid',
  useMockProgress: true,
  withCredentials: false,
};
